import React, { useState } from 'react';
import SelectBoxs from '@components/form/SelectBoxs';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import PropTypes from 'prop-types';
import { MsB2b } from '../../../api/ms-b2b';

const propTypes = {
  editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  isAll: PropTypes.bool,
  orderIdCustomer: PropTypes.string,
  keywordFor: PropTypes.string,
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  loading: false,
  customFilter: {},
  value: '',
  isAll: false,
  orderIdCustomer: '',
  keywordFor: '',
};

const limit = 10;
const sort = '_id';

const SourceDocument = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    loading: isLoadingProps = false,
    customFilter = {},
    hasError = false,
    value = '',
    isAll = false,
    keywordFor = '',
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);
  const SourceDocReturn = useApi(MsOrder.SourceDocReturn);
  const SourceDocReturnSearch = useApi(MsB2b.getSourcerSearch);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {};
      let response = '';
      if (customFilter && Object.keys(customFilter).length) {
        filter = customFilter;
      }
      if (!val && filter.keyword) {
        delete filter.keyword;
      }

      if (val) {
        filter.keyword = val;
        if (keywordFor) {
          filter.keyword_for = keywordFor;
        }
        response = await SourceDocReturnSearch.request({
          params: {
            filter: filter,
            skip: newSkip,
            limit: limit,
            sort: sort,
          },
        });
      } else {
        response = await SourceDocReturn.request({
          params: {
            filter: filter,
            skip: newSkip,
            limit: limit,
            sort: sort,
          },
        });
      }

      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          if (isAll) {
            result.unshift({ id: 'all', name: 'All' });
          }
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBoxs
      label="Source Document"
      options={options}
      value={value}
      orderIdCustomer={value}
      placeholder={
        loading.initial || loading.loadMore
          ? 'Loading...'
          : 'Select Source Documents'
      }
      trackBy="id"
      labelKey="reference_code"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial && !isLoadingProps}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        // reference_code
        if (isAll) {
          const allValue = { id: 'all', name: 'All' };
          if (multiple) {
            if (val?.length <= 0) {
              val.push(allValue);
            } else {
              const idx = val.findIndex((c) => c.id == 'all');
              if (idx > -1 && val?.length > 1) {
                const childIdx = value?.findIndex((c) => c.id == 'all');
                if (childIdx > -1) {
                  val.splice(idx, 1);
                } else {
                  val = [allValue];
                }
              }
            }
          } else {
            if (!val?.id) {
              val = allValue;
            }
          }
        }
        props.onChange(val);
      }}
      onReady={() => {
        if (!isLoadingProps) {
          setSkip(0);
          onSearch();
        }
      }}
    />
  );
};

SourceDocument.propTypes = propTypes;
SourceDocument.defaultProps = defaultProps;

export default SourceDocument;
